export const COEFFICIENTS = {
  age: -0.0348,
  sex: 0.1996,
  nstemi: 0.8698,
  eGFR: -0.0203,
  hemo: -0.0124,
  albuminuriaMild: 0.0880,
  albuminuriaHEavy: 0.6818,
  diabetes: 0.7648,
  priorInv: -0.0216,
  interceptTerm: -5.8343
};

export const BASELINES = {
  age: -77.14,
  eGFR: -51.41,
  hemo: -126.74
};

export const FACTOR = {
  conservativeMgmt: 1 / 1.20
};
